module.exports = __webpack_public_path__ + "media/Video 36a.6dff2c83.mp4";